<div *ngIf="showSplash" class="preloader" [ngStyle]="{'opacity': opacityChange, 'transition': splashTransition}" [hidden]="!opacityChange">
    <div class="app-splash-inner">
      <div data-text="Loading ..." class="loading-text">Loading ...</div>
    </div>
  </div>